import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Globe2, Users, PackageCheck } from 'lucide-react';
const features = [{
  icon: Globe2,
  title: 'Strong Retail Networks',
  description: 'Direct relationships with major hypermarkets and retail chains across the UK, Europe, and Asia including Tesco, Carrefour, Aldi, and more.'
}, {
  icon: Shield,
  title: 'Verified Manufacturers',
  description: 'Access to a global database of reliable, verified manufacturers and producers across all major product categories.'
}, {
  icon: Users,
  title: 'Expert Negotiation',
  description: 'Professional negotiation and procurement expertise that secures competitive pricing and favorable commercial terms.'
}, {
  icon: PackageCheck,
  title: 'End-to-End Support',
  description: 'Complete supply chain management from sourcing and compliance to logistics, market entry, and product promotion.'
}];
export function AboutSection() {
  return <section id="about" className="relative py-24 bg-[#0a1628] overflow-hidden" data-id="element-39">
      {/* Diagonal Background Element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#1a2d4a]/20 hidden lg:block" style={{
      clipPath: 'polygon(20% 0, 100% 0, 100% 100%, 0% 100%)'
    }} data-id="element-40" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-41">
        <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-42">
          {/* Left Column - Sticky Header */}
          <div className="w-full lg:w-1/3 lg:sticky lg:top-32" data-id="element-43">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-44">
              <div className="flex items-center gap-3 mb-6" data-id="element-45">
                <div className="h-px w-12 bg-[#d4a853]" data-id="element-46" />
                <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm" data-id="element-47">
                  Why Partner With Us
                </span>
              </div>

              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-48">
                Your Strategic Partner in <br data-id="element-49" />
                <span className="text-[#d4a853]" data-id="element-50">Global Retail</span>
              </h2>

              <p className="text-gray-400 text-lg leading-relaxed mb-8" data-id="element-51">
                We act as a strategic bridge between global manufacturers and
                major retail buyers, ensuring smooth commercial transactions and
                long-term partnerships. With deep market knowledge and strong
                supplier networks, we bridge the gap between supply and demand.
              </p>

              <button className="text-white border-b border-[#d4a853] pb-1 hover:text-[#d4a853] transition-colors uppercase tracking-wider text-sm font-bold" data-id="element-52">
                Explore Our Services
              </button>
            </motion.div>
          </div>

          {/* Right Column - Feature Grid */}
          <div className="w-full lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-53">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="group p-8 border border-white/10 bg-[#0a1628] hover:bg-[#1a2d4a] transition-colors duration-300 relative overflow-hidden" data-id="element-54">
                <div className="absolute top-0 right-0 w-24 h-24 bg-[#d4a853]/5 rounded-bl-full -mr-4 -mt-4 transition-transform group-hover:scale-150 duration-500" data-id="element-55" />

                <feature.icon className="w-10 h-10 text-[#d4a853] mb-6 relative z-10" data-id="element-56" />

                <h3 className="text-xl font-bold text-white mb-3 relative z-10 group-hover:text-[#d4a853] transition-colors" data-id="element-57">
                  {feature.title}
                </h3>

                <p className="text-gray-400 leading-relaxed relative z-10 group-hover:text-gray-300" data-id="element-58">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}